function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUp = function SvgUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "62.3 0.8 76.6 97.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 5.7097,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M112.2,57.7v25.7             c0,6.4-5.2,11.6-11.6,11.6l0,0C94.2,95,89,89.8,89,83.4V57.7",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 5.7097,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M112.2,57.6h16.2             c6.1,0,9.7-6.9,6.2-11.9L107.7,7.4c-3.5-5-10.9-5-14.4,0L66.5,45.8c-3.5,5,0.1,11.9,6.2,11.9H89",
    fill: "currentColor"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/up.5f9958a2.svg";
export { ForwardRef as ReactComponent };